var Vue = window.Vue;
var vm;
if (!Vue) {
    Vue = require('vue');
}
if ($('#agents-reports').length > 0) {
    var vm = new Vue({
        el: '#agents-reports',
        components: {
            'bookings-by-agents': require('./components/BookingsByAgents'),
        },
    });
}

module.exports = vm;



// WEBPACK FOOTER //
// ./resources/scripts/portal/components/agents/Reports.js